import { isEmpty, clone, isEqual, isNumber, isFinite } from 'lodash';
import Dropdown from 'react-select';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import React from 'react';

import { MEDIA_QUERIES } from '@sm360/widget-commons-general';

import 'react-select/dist/react-select.css';
import 'commons-forms/components/InputDropDown/InputDropDown.scss';

class InputDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.getDropdownValue = this.getDropdownValue.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeMobile = this.onChangeMobile.bind(this);
        this.valueIsValid = this.valueIsValid.bind(this);
    }

    shouldComponentUpdate(newProps) {
        return (
            (newProps.value && !isEqual(this.props.value, newProps.value)) ||
            !isEqual(this.props.options, newProps.options) ||
            !isEqual(this.props.hasBeenSubmit, newProps.hasBeenSubmit)
        );
    }

    onChange(selectedOption) {
        this.props.valueChange(selectedOption, this.props.name);
    }

    onChangeMobile(e) {
        const selectedValue = e.nativeEvent.target.value;
        const selectedOption = this.props.options.find((option) => {
            return option.value.toString() === selectedValue.toString();
        });

        this.onChange(selectedOption, this.props.name);
    }

    getDropdownValue() {
        const valueSelected = this.props.value;

        if (this.props.options) {
            const value = this.props.options.find((option) => {
                return option.value === valueSelected;
            });
            return value ? value.value : null;
        }
        return null;
    }

    valueIsValid() {
        if (isNumber(this.props.value)) {
            return isFinite(this.props.value);
        }
        return !!this.props.value && !isEmpty(this.props.value);
    }

    render() {
        const dropdownClassNames = clone(this.props.classNames);
        const value = this.getDropdownValue();

        dropdownClassNames.push('styled-placeholder');
        dropdownClassNames.push('dropdown');

        if (!this.valueIsValid() && this.props.hasBeenSubmit && this.props.isRequired) {
            dropdownClassNames.push('field-error');
        } else if (this.valueIsValid()) {
            dropdownClassNames.push('not-empty');
        }

        const mobileOptions = this.props.options.map((option) => (
            <option key={option.value} value={option.value} selected={option.value === value}>
                {option.label}
            </option>
        ));

        mobileOptions.unshift(
            <option key="mobile-placeholder" disabled selected>
                {this.props.placeholder}
            </option>
        );

        const DropdownValueComponent = (props) => (
            <div className="Select-value" role="listbox" aria-label={props.children}>
                <span className="Select-value-label" role="option" aria-selected="true" id={props.id}>
                    {props.children}
                </span>
            </div>
        );

        return (
            <div className={dropdownClassNames.join(' ')}>
                <label className="input-label" htmlFor={this.props.name}>
                    {this.props.placeholder}
                </label>
                <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                    <Dropdown
                        name={this.props.name}
                        value={value}
                        placeholder={this.props.placeholder || ''}
                        options={this.props.options}
                        optionClassName="Select-menu-option"
                        onChange={this.onChange}
                        multi={false}
                        clearable={false}
                        autoblur
                        disabled={this.props.disabled}
                        aria-label={this.props.placeholder || this.props.name}
                        valueComponent={DropdownValueComponent}
                    />
                </MediaQuery>
                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                    <select
                        className="Select-control"
                        name={this.props.name}
                        onChange={this.onChangeMobile}
                        value={value}
                        disabled={this.props.disabled}
                    >
                        {mobileOptions}
                    </select>
                    <span role="button" tabIndex={0} className="Select-arrow-zone">
                        <span role="presentation" className="Select-arrow" />
                    </span>
                </MediaQuery>
                {!isEmpty(this.props.errorLabel) && <p className="errors-input">{this.props.errorLabel}</p>}
            </div>
        );
    }
}

InputDropdown.defaultProps = {
    classNames: [],
    errorLabel: '',
    isRequired: false,
    hasBeenSubmit: false,
    options: [],
    placeholder: '',
    value: '',
    disabled: false,
};

InputDropdown.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string.isRequired,
    errorLabel: PropTypes.string,
    isRequired: PropTypes.bool,
    hasBeenSubmit: PropTypes.bool,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
        })
    ),
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.bool.isRequired, PropTypes.number.isRequired]),
    valueChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

InputDropdown.displayName = 'InputDropdown';

export default InputDropdown;
